module.exports = __webpack_public_path__ + "img/世界港口及航线.6ce0fdff.png";